import { DocumentType } from './DocumentType';

export const JokerTypes = {
  SOURCELIST: 'SOURCELIST',
  PRODUCTION: 'PRODUCTION',
  ITEM: 'ITEM',
  PROJECT: 'PROJECT',
  COMPLAINT: 'COMPLAINT',
  EMPLOYEE: 'EMPLOYEE',
  COMPANY: 'COMPANY',
  RESOURCEONE: 'RESOURCEONE',
  RESOURCETWO: 'RESOURCETWO',
  RESOURCETHREE: 'RESOURCETHREE',
  RESOURCEFOUR: 'RESOURCEFOUR',
  RESOURCEFIVE: 'RESOURCEFIVE',
  WEBUSER: 'WEBUSER',
  OTHEREXPENSE: 'OTHEREXPENSE',
  PLANTASK: 'PLANTASK',
  TASKLIST: 'TASKLIST',
};

export const JokerUngroupedOption = {
  label: 'Sorszintű',
  value: -1,
};

export const JokerTypeList = [
  { label: 'Forrásjegyzék', value: JokerTypes.SOURCELIST },
  { label: 'Gyártás', value: JokerTypes.PRODUCTION },
  { label: 'Cikkek', value: JokerTypes.ITEM },
  { label: 'Projekt', value: JokerTypes.PROJECT },
  { label: 'Reklamáció kezelés', value: JokerTypes.COMPLAINT },
  { label: 'Dolgozók', value: JokerTypes.EMPLOYEE },
  { label: 'Üzleti partnerek', value: JokerTypes.COMPANY },
  { label: 'Erőforrás 1', value: JokerTypes.RESOURCEONE },
  { label: 'Erőforrás 2', value: JokerTypes.RESOURCETWO },
  { label: 'Erőforrás 3', value: JokerTypes.RESOURCETHREE },
  { label: 'Erőforrás 4', value: JokerTypes.RESOURCEFOUR },
  { label: 'Erőforrás 5', value: JokerTypes.RESOURCEFIVE },
  { label: 'Felhasználók', value: JokerTypes.WEBUSER },
  { label: 'Egyéb költségek', value: JokerTypes.OTHEREXPENSE },
  { label: 'Tervező feladatok', value: JokerTypes.PLANTASK },
  { label: 'Feladatlista', value: JokerTypes.TASKLIST },
  //bizonylatok a felületen kerülnek az autocompletebe, az erőforrások pedig ott kapják meg a menü megnevezést.
];

export const JokerFieldTypes = {
  TEXT: 'text',
  SELECT: 'select',
  NUMBER: 'number',
  DATE: 'date',
};

export const JokerFieldShortNames = {
  CHAR: 'CHAR',
  INT: 'INT',
  NUM: 'NUM',
  DATE: 'DATE',
};

export const JokerFieldShortNamePrefix = {
  [JokerFieldShortNames.CHAR]: 'joker_char',
  [JokerFieldShortNames.DATE]: 'joker_date',
  [JokerFieldShortNames.NUM]: 'joker_num',
  [JokerFieldShortNames.INT]: 'joker_int',
};

export const JokerFieldsCountByType = {
  [JokerTypes.SOURCELIST]: {
    [JokerFieldShortNames.CHAR]: 25,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 7,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 1,
      [JokerFieldShortNames.NUM]: 2,
    },
  },
  [JokerTypes.PRODUCTION]: {
    [JokerFieldShortNames.CHAR]: 28,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 9,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 2,
      [JokerFieldShortNames.NUM]: 2,
    },
  },
  [JokerTypes.ITEM]: {
    [JokerFieldShortNames.CHAR]: 36,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.PROJECT]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 15,
    [JokerFieldShortNames.INT]: 5,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 10,
      [JokerFieldShortNames.DATE]: 5,
      [JokerFieldShortNames.NUM]: 5,
      [JokerFieldShortNames.INT]: 5,
    },
  },
  [JokerTypes.COMPLAINT]: {
    [JokerFieldShortNames.CHAR]: 5,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.EMPLOYEE]: {
    [JokerFieldShortNames.CHAR]: 45,
    [JokerFieldShortNames.DATE]: 9,
    [JokerFieldShortNames.NUM]: 15,
    [JokerFieldShortNames.INT]: 5,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 10,
      [JokerFieldShortNames.DATE]: 5,
      [JokerFieldShortNames.NUM]: 15,
      [JokerFieldShortNames.INT]: 5,
    },
  },
  [JokerTypes.COMPANY]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  ...Object.fromEntries(
    Object.keys(DocumentType).map((key) => [
      key.toUpperCase(),
      {
        [JokerFieldShortNames.CHAR]: 10,
        [JokerFieldShortNames.DATE]: 5,
        [JokerFieldShortNames.NUM]: 5,
        [JokerFieldShortNames.INT]: 5,
        ROWS: {
          [JokerFieldShortNames.CHAR]: 10,
          [JokerFieldShortNames.DATE]: 5,
          [JokerFieldShortNames.NUM]: 5,
          [JokerFieldShortNames.INT]: 5,
        },
      },
    ])
  ),
  [JokerTypes.RESOURCEONE]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.RESOURCETWO]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.RESOURCETHREE]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.RESOURCEFOUR]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.RESOURCEFIVE]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.WEBUSER]: {
    [JokerFieldShortNames.CHAR]: 2,
  },
  [JokerTypes.OTHEREXPENSE]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
    ROWS: {
      [JokerFieldShortNames.CHAR]: 10,
      [JokerFieldShortNames.DATE]: 5,
      [JokerFieldShortNames.NUM]: 5,
      [JokerFieldShortNames.INT]: 5,
    },
  },
  [JokerTypes.PLANTASK]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
  [JokerTypes.TASKLIST]: {
    [JokerFieldShortNames.CHAR]: 10,
    [JokerFieldShortNames.DATE]: 5,
    [JokerFieldShortNames.NUM]: 5,
    [JokerFieldShortNames.INT]: 5,
  },
};
